// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__iSjDb","loading__spinner":"styles_loading__spinner__2lfir"};